import { useMemo } from "react";

export const Sparkles = ({ count = 10, className = "" }) => {
  const sparks = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: (i * 97 + 13) % 100,
        top: (i * 53 + 29) % 100,
        dur: `${2.4 + ((i * 7) % 20) / 10}s`,
        delay: `${((i * 11) % 30) / 10}s`,
      })),
    [count]
  );
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {sparks.map((s, i) => (
        <span
          key={i}
          className="sparkle"
          style={{ left: `${s.left}%`, top: `${s.top}%`, "--tw-dur": s.dur, "--tw-delay": s.delay }}
        />
      ))}
    </div>
  );
};

export const ShimmerCard = ({ children, className = "" }) => (
  <div className={`shimmer-border ${className}`}>
    <div className="relative rounded-[inherit] h-full">{children}</div>
  </div>
);